// extracted by mini-css-extract-plugin
module.exports = {"feedback":"_27yjp","highlight":"_1h-bB","content":"_1whwb"};